export const getDemoEmail = (): string | null => {
  const email = import.meta.env?.VITE_DEMO_EMAIL
  const trimmed = typeof email === 'string' ? email.trim() : ''
  return trimmed ? trimmed.toLowerCase() : null
}

export const isDemoUser = (email?: string | null): boolean => {
  if (!email) return false
  const demoEmail = getDemoEmail()
  if (!demoEmail) return false
  return email.toLowerCase() === demoEmail
}

